import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastProvider } from './contexts/ToastContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen from './components/LoadingScreen';
import Home from './pages/Home';
import Products from './pages/Products';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import BookingSuccess from './pages/BookingSuccess';
import Categories from './pages/Categories';
import Contact from './pages/Contact';
import ProductDetails from './pages/ProductDetails';
import Login from './pages/Login';
import Register from './pages/Register';
import Wishlist from './pages/Wishlist';
import MyOrders from './pages/MyOrders';
import MyAccount from './pages/MyAccount';
import MyAddress from './pages/MyAddress';
import ChangePassword from './pages/ChangePassword';
import RefundPolicy from './pages/RefundPolicy';
import './App.css';

function App() {
  const [appReady, setAppReady] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setAppReady(true), 800);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <div className={`loading-screen-wrapper ${appReady ? 'loading-screen-wrapper-hidden' : ''}`}>
        <LoadingScreen />
      </div>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <ToastProvider>
          <ScrollToTop />
          <div className="App">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/product/:id/:name" element={<ProductDetails />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/my-orders" element={<MyOrders />} />
              <Route path="/account" element={<MyAccount />} />
              <Route path="/my-address" element={<MyAddress />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/booking-success" element={<BookingSuccess />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </ToastProvider>
    </Router>
    </>
  );
}
export default App;
